<div class="wrapper-page faq-page">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <div class="wrapper-back-btn">
        <div class="back-btn" [routerLink]="[
        PAGES_AND_PATHS.businessList.pagePath,
        categoryId === 'all'
            ? 'all'
            : (businessData?.business_category_id || 'new')
     ]">
          <i class="fa-solid fa-chevron-left"></i>
        </div>
        <span class="header-text">Biznis profil
          <img *ngIf="businessData?.identification_number === '63437433'" style="margin-left: 8px;" src="../../../../assets/icons/landing/star-rating.svg" alt="">
        </span>
      </div>
      <div class="zc-d-flex zc-align-items">
        <div class="wrapper-verification">
          <button *ngIf="!businessData?.user?.email_verified_at" (click)="approveUser()" class="zc-btn zc-btn--primary">Verifikuj</button>
          <span *ngIf="businessData?.user?.email_verified_at" class="span-approved">Verifikovan</span>
        </div>
        <div *ngIf="isBusinessProfileRequestFinished && isBusinessApproved === null">
          <button class="zc-btn zc-btn--primary" (click)="approveOrRejectBusinessProfile(1)">Odobri</button>
          <button class="zc-btn zc-btn--delete xs-ml-16" (click)="approveOrRejectBusinessProfile(0)">Odbij</button>
        </div>
        <span [ngClass]="isBusinessApproved ? 'span-approved' : 'span-rejected'"
          *ngIf="isBusinessProfileRequestFinished && isBusinessApproved !== null">{{isBusinessApproved ? 'Odobren' : 'Odbijen'}}</span>
      </div>
    </div>
    <div class="zc-wrapper-tabs">
      <div (click)="activeTab = businessProfileTabs.baseData" class="zc-tab"
           [ngClass]="{'active': activeTab === businessProfileTabs.baseData}">
        <span>Osnovni podaci</span>
      </div>
      <div (click)="activeTab = businessProfileTabs.category" class="zc-tab"
           [ngClass]="{'active': activeTab === businessProfileTabs.category}">
        <span>Cenovnik</span>
      </div>
      <div *ngIf="businessData?.business_category_id === 1" (click)="activeTab = businessProfileTabs.terms" class="zc-tab"
           [ngClass]="{'active': activeTab === businessProfileTabs.terms}">
        <span>Termini</span>
      </div>
      <div *ngIf="businessData?.business_category_id === 1" (click)="activeTab = businessProfileTabs.newTerms" class="zc-tab"
           [ngClass]="{'active': activeTab === businessProfileTabs.newTerms}">
        <span>Novi Termini</span>
      </div>
    </div>
    <!--   Osnovni podaci   -->
    <gr-base-data
      [hidden]="activeTab !== businessProfileTabs.baseData"
      [listOfCategories]="listOfCategories"
      [isNewBusiness]="isNewBusiness"
      [businessProfileData]="businessData">
    </gr-base-data>
    <!--   Kategorije   -->
    <gr-categories
      [hidden]="activeTab !== businessProfileTabs.category"
      [listOfCategories]="listOfCategories"
      [categoryId]="businessData?.business_category_id">
    </gr-categories>
    <!--   Termini   -->
    <div *ngIf="activeTab === businessProfileTabs.terms" class="wrapper-terms xs-p-32">
      <gr-terms
        [urlParams]="urlParams"
      ></gr-terms>
      <div class="grid">
        <div class="grid__m-6">

        </div>
      </div>
    </div>
    <div *ngIf="activeTab === businessProfileTabs.newTerms" class="wrapper-terms xs-p-32">
      <app-slot-management [urlParams]="urlParams"></app-slot-management>
    </div>
  </div>
</div>
